<template>
  <client-only>
    <confirmation-page :info="pageInfo" @submit="submit()"></confirmation-page>
  </client-only>
</template>
<script>
import ConfirmationPage from '@/components/Commons/ConfirmationPage'
export default {
  components: {
    ConfirmationPage
  },
  data() {
    return {
      pageInfo: {
        title: this.$t('Payment Unsuccessful'),
        image: '/images/misc/failed.svg',
        maintext: this.$t('Your Transaction could not be processed'),
        subtext: this.$t(
          'We could not acquire the payment. Please try again or use a different payment method.'
        ),
        color: 'dark-red'
      }
    }
  },
  methods: {
    submit() {
      this.$router.push(
        this.localePath({
          name: 'payment-cart-summary'
        })
      )
    }
  }
}
</script>
